import { render, staticRenderFns } from "./EditMarketGoodsItem.vue?vue&type=template&id=0a7eb2fc"
import script from "./EditMarketGoodsItem.vue?vue&type=script&lang=js"
export * from "./EditMarketGoodsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports